import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class FeatureImage {
  constructor(element) {
    this.element = element;
    this.media = this.element.querySelector('.feature-image__media');
    this.img = this.element.querySelector('img');
    this.overlay = this.element.querySelector('.feature-image__overlay');

    this.init();
  }

  init = () => {
    gsap.from(this.media, {
      y: 300,
      opacity: 0,
      ease: 'back.out(1.9)',
      duration: 0.6,
      scrollTrigger: {
        trigger: this.element,
        start: 'top bottom',
        toggleActions: 'restart none none none',
      },
    });

    gsap.set(this.overlay, { xPercent: -100, opacity: 0 });

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const start = isMobile ? 'center center+=20px' : 'center center';
    const tl = gsap.timeline({
      duration: 1,
      scrollTrigger: {
        trigger: this.element, start: start, end: isMobile ? '+=100%' : '+=300%',
        pin: true,
        scrub: true,
        onEnter: () => {
          gsap.to(this.overlay, { xPercent: -100, opacity: 0 });
        },
        onEnterBack: () => {
          gsap.to(this.overlay, { xPercent: -100, opacity: 0 });
        },
        onUpdate: (self) => {
          let direction = tl.scrollTrigger.direction;
          if (self.progress >= 0.60 && direction == 1) {
            if (!this.overlay) return;
            gsap.to(this.overlay, { xPercent: 0, opacity: 1, ease: 'power2.out', duration: 0.8 });
          }
        },
        onLeave: () => { },
      },
    });

    const clipStart = isMobile
      ? 'inset(calc(50% - 180px) calc(50% - 140px) calc(50% - 180px) calc(50% - 140px) round 20px)'
      : 'inset(calc(50% - 265px) calc(50% - 200px) calc(50% - 265px) calc(50% - 200px) round 30px)';
    tl.fromTo(this.media, { clipPath: clipStart }, { clipPath: 'inset(calc(0% - 0px) calc(0% - 0px) calc(0% - 0px) calc(0% - 0px) round 30px)', ease: 'none', duration: 3, }, 0);

    tl.fromTo(this.img, { scale: 1.2 }, { scale: 1, duration: 4 }, 0);

  }
}
